import React, { useState, useEffect } from "react";

import SelectClient from "../SelectOptions/SelectClient";
import SelectTypeSale from "../SelectOptions/SelectTypeSale";
/**importar spinner */
import Spinner from "../../Complements/Spinner";
import { Grid, Button, Tooltip, IconButton } from "@material-ui/core";
import Exceltojson from "./exceltojson";
import PlantillaExcel from "./ProductsExportExcel";
import ModalClient from "./ModalClient";
import PersonAddIcon from "@material-ui/icons/PersonAdd";

const SelectsComponent = ({
  guardarProductoID,
  guardarClienteID,
  id,
  clienteID,
  saveProductsBranded,
  detectarCambiosTypeSale,
}) => {
  const detectarCambiosClient = (value) => {
    guardarClienteID(value.value);
  };
  const [cargando, spinnerCargando] = useState(false);

  //cliente
  useEffect(() => {
    spinnerCargando(true);
    guardarClienteID(clienteID);
  }, [clienteID]);

  //MODAL CLIENT
  const [openModalClient, setOpenModalClient] = React.useState(false);

  const handleClickOpenModalClient = () => {
    setOpenModalClient(true);
  };
  const handleCloseModalClient = () => {
    setOpenModalClient(false);
  };

  if (!cargando) return <Spinner />;

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        {/* Client selector + New button */}
        <Grid item xs={12} md={5}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ flex: 1 }}>
              <SelectClient
                detectarCambiosClient={detectarCambiosClient}
                id_branch_office={id}
              />
            </div>
            <Tooltip title="Registrar nuevo cliente" arrow>
              <IconButton
                onClick={handleClickOpenModalClient}
                style={{
                  background: "linear-gradient(135deg, #1a237e 0%, #4a148c 100%)",
                  color: "#fff",
                  width: 38,
                  height: 38,
                  borderRadius: 10,
                }}
              >
                <PersonAddIcon style={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>

        {/* Sale type */}
        <Grid item xs={12} md={4}>
          <SelectTypeSale detectarCambiosTypeSale={detectarCambiosTypeSale} />
        </Grid>

        {/* Excel tools */}
        <Grid item xs={12} md={3}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <PlantillaExcel id={id} />
            <Exceltojson saveProductsBranded={saveProductsBranded} />
          </div>
        </Grid>
      </Grid>

      <ModalClient
        modal={openModalClient}
        handleClose={handleCloseModalClient}
        id={id}
      />
    </>
  );
};

export default SelectsComponent;
